import {
    EmployeeType,
    HirarchyFilterGroup,
    IHierachyFilterCache,
    IHierachyFilterCacheUrlInfo,
    UserLocation,
    PageLocationFilters,
} from '../../../interfaces/user-location';

export class HierarchyFiltersCustomOptions {
    constructor() {}
    // TODO: Find a more dynamic way to add or remove employee positions to Hierarchy filters
    // ----Moving to database canbe considered as an alternative
    hierarchyGroupUrlInfoList: IHierachyFilterCacheUrlInfo[] = [
        {
            url: '/performance/at-a-glance',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/financials/at-a-glance',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/pipeline/at-a-glance',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: false,
            isUseActivityDate: true,
        },
        {
            url: '/production/at-a-glance',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: false,
            isUseActivityDate: true,
        },
        {
            url: '/historical-trends/at-a-glance',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: false,
            isUseActivityDate: true,
        },
        {
            url: '/performance/insights/kpi-sparkline',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/performance/insights/kpi',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/performance/insights/kpi-employee',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/performance/insights/weighted-rankings',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/performance/insights/performance-rankings-position',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/performance/insights/performance-rankings-branch',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/performance/insights/branch-leaderboard',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/financials/insights/profitability',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/financials/insights/revenue-trends',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/totalHeadcount',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/totalProducers',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/totalOpsSupport',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/topProducersByscore',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/bottomTenuredProducers',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/projectionsYTDActuals_Units',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/projectionsYTDActuals_Volume',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/projectionsYTDActuals_PurchaseLoans',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/projectionsYTDActuals_GovernmentLoans',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/performance/projectionsYTDActuals_TenuredProducers',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/pipeline/activity-tracker',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/activity-tracker',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/pipeline-tracker',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: false,
            showPosition: false,
        },
        {
            url: '/pipeline/insights/pipeline-with-position-assigned',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/insights_positionAssignments',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/insights_positionAssignmentsByLoanPurpose',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/insights_positionAssignmentsByLoanStatus',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/insights_positionAssignmentsByLoanType',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/insights_positionAssignmentsByLockStatus',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/insights_currentPipeline',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/insights_upcomingAssignments',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
            //defaultPosition: 'Closer',
        },
        {
            url: '/pipeline/insights/sales-funnel',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/production/insights/production-turn-times',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/aging-loans',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
            addExtraPositions: true,
            filterType: 'PR',
        },
        {
            url: '/reporting/production/insights_productionTurnTimesByMilestone',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/pipeline/pipeline-processing-details',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/insights_productionTurnTimesByMilestone_all',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/insights_productionTurnTimesFunded',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/insights_productionTurnTimesFunded_all',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/insights_productionTurnTimesByMilestone_position_all',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/insights_productionTurnTimesByMilestone_position',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/production/insights/milestone-utilization',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/historical-trends/insights/headcount-trends',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/production/insights/eclose-roi-trends',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/production/insights/eclose-adoption-trends',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/loans-funded-by',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/insights_estimatedECloseSaving',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/insights_estimatedSavingByECloseMethod',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/insights_averageCostSavingPerLoan',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/reporting/production/appToFund_with_position',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
        {
            url: '/performance/insights/monthly-lo-rankings',
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            excludeEmployee: true,
        },
        {
            url: '/reporting/production/milestone-utilization',
            hierarchyGroupId: HirarchyFilterGroup.employeePositionHierarchy,
            excludeEmployee: false,
            showPosition: true,
        },
    ];

    getEmployeeType(url: string) {
        // TODO: move this to hierarchyGroupUrlInfoList
        let employeeType: EmployeeType;
        let routerList = [
            /*'/incentives/at-a-glance'*/
        ];
        let employeeUrl = routerList.find((item) => item === url);

        employeeType = EmployeeType.loanOriginator;
        if (employeeUrl || url.includes('/performance/')) {
            employeeType = EmployeeType.otherEmployee;
        }
        return employeeType;
    }

    getHierarchyCachePageInfo(url: string) {
        let hierarchyGroupUrlInfo = this.hierarchyGroupUrlInfoList.find(
            (urlInf) => urlInf.url.toLowerCase() === url.toLowerCase()
        );

        let hierarchyCachePageInfo: IHierachyFilterCacheUrlInfo = {
            excludeEmployee: false,
            showPosition: false,
            url: url,
            employeeType: this.getEmployeeType(url),
            hierarchyGroupId: HirarchyFilterGroup.genaralHierarchy,
            isUseActivityDate: true,
        };

        if (hierarchyGroupUrlInfo) {
            hierarchyCachePageInfo.excludeEmployee = hierarchyGroupUrlInfo.excludeEmployee ?? false;
            hierarchyCachePageInfo.showPosition = hierarchyGroupUrlInfo.showPosition ?? false;
            hierarchyCachePageInfo.hierarchyGroupId =
                hierarchyGroupUrlInfo.hierarchyGroupId ?? HirarchyFilterGroup.genaralHierarchy;
            hierarchyCachePageInfo.defaultPosition = hierarchyGroupUrlInfo.defaultPosition ?? null;
            hierarchyCachePageInfo.addExtraPositions =
                hierarchyGroupUrlInfo.addExtraPositions ?? false;
            hierarchyCachePageInfo.filterType = hierarchyGroupUrlInfo.filterType ?? 'P';
        }
        hierarchyCachePageInfo.isUseActivityDate = true;
        return hierarchyCachePageInfo;
    }

    getPageCache(
        hierarchyGroupId: HirarchyFilterGroup,
        hierarchyCache: IHierachyFilterCache,
        isSavedFilter = false
    ) {
        let hierarchyPageCache: UserLocation[] = [];
        if (!hierarchyCache) {
            hierarchyCache = JSON.parse(localStorage.getItem('mainFilters'));
        }
        let appCurrentVersion = localStorage.getItem('version');
        if (hierarchyCache && !isSavedFilter) {
            if (hierarchyCache.version !== appCurrentVersion) {
                localStorage.removeItem('mainFilters');
                return [];
            }
        }

        if (hierarchyCache) {
            hierarchyPageCache = hierarchyCache.commonHierarchy
                ? hierarchyCache.commonHierarchy
                : [];

            let hierarchyPositionCache =
                hierarchyCache.positionHierarchy && hierarchyCache.positionHierarchy.length > 0
                    ? hierarchyCache.positionHierarchy.find(
                          (item) => item.hierarchyGroupId === hierarchyGroupId
                      )
                    : null;

            hierarchyPageCache = hierarchyPageCache.concat(
                hierarchyPositionCache && hierarchyPositionCache.empployees
                    ? hierarchyPositionCache.empployees
                    : []
            );
        }
        return hierarchyPageCache;
    }

    getHierarchyFilters(url: string): string {
        let hierarchyCachePageInfo = this.getHierarchyCachePageInfo(url);
        let hierarchyPageCache: UserLocation[] = this.getPageCache(
            hierarchyCachePageInfo.hierarchyGroupId,
            null
        );
        const finalFiltersToPages: PageLocationFilters[] = [];
        for (const hierarchy of hierarchyPageCache) {
            let selectArrayName = '';
            let hierarchyId = '';

            if (hierarchy.isEmployee) {
                selectArrayName = 'employeeSelectedItemArray';
                hierarchyId = 'employeeIdentifier';
            } else {
                selectArrayName = 'roleSelectedItemArray';
                hierarchyId = 'hierarchyIdentifier';
            }
            let hierarchyDetails = hierarchy[selectArrayName];

            if (!(hierarchy.isEmployee && this.getHierarchyCachePageInfo(url).excludeEmployee)) {
                if (hierarchyDetails && hierarchyDetails.length > 0) {
                    for (let hDetail of hierarchyDetails) {
                        let roleName = hDetail.roleName;

                        if (
                            hierarchy.isStaffPosition &&
                            hierarchy.staffPositionSelectedItemArray &&
                            hierarchy.staffPositionSelectedItemArray.length > 0
                        ) {
                            roleName = hierarchy.staffPositionSelectedItemArray[0].positionAbbv;
                        }

                        finalFiltersToPages.push({
                            Hierarchy: {
                                rolename: roleName,
                                hierarchyidentifier: hDetail[hierarchyId],
                            },
                        });
                    }
                }
            }
        }
        return JSON.stringify(finalFiltersToPages);
    }

    setHierarchyFiltersToSave(
        pageHierarchyFilters: UserLocation[],
        hierarchyCache: IHierachyFilterCache,
        pageHierarcyFilterGroup: HirarchyFilterGroup,
        applyNewFilter = false
    ) {
        //TODO: Check hierarchyCache.commonHierarchy and new commonHierarchy is the same;
        // if they are the same, keep old empoyee values; i.e. make applyNewFilter = false

        let commonHierarchy: UserLocation[] = pageHierarchyFilters.filter(
            (item) => item.isEmployee === undefined || item.isEmployee === false
        );
        let employeeFilters: UserLocation[] = pageHierarchyFilters.filter(
            (item) => item.isEmployee === true
        );

        if (hierarchyCache && !applyNewFilter) {
            hierarchyCache.commonHierarchy = commonHierarchy;
            hierarchyCache.version = localStorage.getItem('version');

            let positionByGroup = hierarchyCache.positionHierarchy.find(
                (item) => item.hierarchyGroupId === pageHierarcyFilterGroup
            );

            if (positionByGroup && positionByGroup.empployees) {
                positionByGroup.empployees = employeeFilters;
            } else {
                hierarchyCache.positionHierarchy.push({
                    hierarchyGroupId: pageHierarcyFilterGroup,
                    empployees: employeeFilters,
                });
            }
        } else {
            hierarchyCache = {
                commonHierarchy: commonHierarchy,
                positionHierarchy: [
                    {
                        hierarchyGroupId: pageHierarcyFilterGroup,
                        empployees: employeeFilters,
                    },
                ],
                version: localStorage.getItem('version'),
            };
        }
        return hierarchyCache;
    }

    saveHierarchyFiltersToCache(
        pageHierarchyFilters: UserLocation[],
        pageHierarcyFilterGroup: HirarchyFilterGroup = HirarchyFilterGroup.genaralHierarchy,
        applyNewFilter = true
    ) {
        let hierarchyCacheOld: IHierachyFilterCache = JSON.parse(
            localStorage.getItem('mainFilters')
        );
        let hierarchyCache = this.setHierarchyFiltersToSave(
            pageHierarchyFilters,
            hierarchyCacheOld,
            pageHierarcyFilterGroup,
            applyNewFilter
        );
        localStorage.setItem('mainFilters', JSON.stringify(hierarchyCache));
    }
}
